// extracted by mini-css-extract-plugin
module.exports = {"container":"Container_container__3eZVY","content":"Container_content__2JowH"};